// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__30uC5","inputWrap":"styles_inputWrap__39Bcn","input":"styles_input__eDt4g"};